<template lang="pug">
    app-dialog(v-model="$_show" header="Вход для участников" width="378")
      .home__login
        app-text-field(v-model="username" label="Логин" :focus="!hasSavedLogin" @keyup.enter="login")
        app-text-field(v-model="password" label="Пароль" :errorText="error"  type="password" :focus="hasSavedLogin" @change="resetError" @keyup.enter="login")

      .text-center(slot="footer")
        app-button-action.mr-0(@click="login") Войти
        div
          Advocatura.mt-6(@login="advLogin")

</template>

<script>
import { mapGetters } from "vuex"
import { userService } from '@/_services'
import { AppDialogToggable } from '@/components'
import { $_user_utils } from '@/common/UserUtils'
import Meeting from '@/common/Meeting'
import Advocatura from './ext/Advocatura'


var getParams = function (url) {
  var parser = document.createElement('a')
  parser.href = url
  
	var query = parser.search.substring(1)
  var vars = query.split('&')
  
  var params = {}
  if (vars.length == 0) return params
  
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=')
		params[pair[0]] = decodeURIComponent(pair[1])
	}
	return params
}

export default {
  mixins: [AppDialogToggable, $_user_utils, Meeting],
  components: {
    Advocatura,
  },
  name: 'login',
  data() {
    return {
      username: '',
      password: '',
      error: null,
    }
  },
  created() {
    this.username = localStorage.getItem("LoginName")
    this.password = ''
  },
  computed: {
    ...mapGetters("me", ["fullname"]),

    hasSavedLogin () {
      return localStorage.getItem("LoginName") ? true : false
    }
  },
  methods: {
    login () {
      let { username, password } = this

      userService.login(username, password).then(status => {
        if (status && this.$user_utils_checkAccess() ) {
            localStorage.setItem("LoginName", username)

            let userUid = localStorage.getItem('useruuid')
            let serialObj = localStorage.getItem("accounts")
            let accounts = serialObj && JSON.parse(serialObj) || []
            let uids = accounts.map(acc => acc.uid)

            const colors = ['red', 'purple', 'deep-purple', 'indigo', 'blue', 'cyan', 'cyan', 'green', 'amber', 'orange', 'deep-orange', 'brown', 'blue-grey', 'grey', 'black']
            const idx = Math.floor(Math.random() * Math.floor(colors.length))

            if (uids.includes(userUid) == false) {
              let fio = localStorage.getItem('fio').replace(/"/g, "")
              accounts.push({ 
                uid: userUid, 
                login: username,
                color: colors[idx],
                fio: fio && fio != 'null' ? fio : username 
              })
              localStorage.setItem("accounts", JSON.stringify(accounts))
            }

            if (this.$_meeting_isAvailable) {
              let fio = `${localStorage.getItem('fio').toString()} (Судья)` || 'Судья'
              
              this.$_meeting_setCookieForUser(userUid, fio, true, false)
  
              let { back } = getParams(window.location.href)
              if (back) {
                location.href = this.$_meeting_makeUrlForRoom(back)
              }
            }

            this.$user_utils_goToStartPage()
        } else {
          this.error = 'Не правильно введен логин или пароль'
        }
      })
    },

    advLogin(req, type) {
      userService.extOauth(req, type).then(status => {
        this.auth(status, type)
      })
    },

    auth(status, username) {
      if (status) {
        localStorage.setItem("LoginName", username)
        this.$user_utils_goToStartPage()
      } else {
        this.error = 'Не правильно введен логин или пароль'
      }
    },

    resetError () {
      this.error = null
    }
  },
}
</script>


